<template>
  <!-- ========================= -->
  <!-- TAB: SWITCHES             -->
  <!-- ========================= -->
  <div
    class="row mt-2 mb-3"
    :style="disableActive ? 'opacity: 0.45; pointer-events: none;' : ''"
  >
    <p class="bb-hdg mt-2 mb-3">Switches</p>
    <div class="row mt-2 mb-2">
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Active`"
          :labelOff="`Inactive`"
          :checked="!!(localItem.active ?? activeItem.active)"
          @update:modelValue="onFlagChange('active', $event)"
        />
      </div>
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Tallyable`"
          :labelOff="`Not Tallyable`"
          :checked="!!(localItem.tallyable ?? activeItem.tallyable)"
          @update:modelValue="onFlagChange('tallyable', $event)"
        />
      </div>
    </div>

    <!-- row 2: countable / wearable -->
    <div class="row mt-2 mb-2">
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Countable`"
          :labelOff="`Not Countable`"
          :checked="!!(localItem.countable ?? activeItem.countable)"
          @update:modelValue="onFlagChange('countable', $event)"
        />
      </div>
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Wearable`"
          :labelOff="`Not Wearable`"
          :checked="!!(localItem.wearable ?? activeItem.wearable)"
          @update:modelValue="onFlagChange('wearable', $event)"
        />
      </div>
    </div>

    <!-- row 3: storeable / storage -->
    <div class="row mt-2 mb-2">
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Storeable`"
          :labelOff="`Not Storeable`"
          :checked="!!(localItem.storeable ?? activeItem.storeable)"
          @update:modelValue="onFlagChange('storeable', $event)"
        />
      </div>
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Storage`"
          :labelOff="`Not Storage`"
          :checked="!!(localItem.storage ?? activeItem.storage)"
          @update:modelValue="onFlagChange('storage', $event)"
        />
      </div>
    </div>

    <!-- row 4: attachable / attach_point -->
    <div class="row mt-2 mb-2">
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Attachable`"
          :labelOff="`Not Attachable`"
          :checked="!!(localItem.attachable ?? activeItem.attachable)"
          @update:modelValue="onFlagChange('attachable', $event)"
        />
      </div>
      <div class="col-6 d-flex justify-content-center">
        <enhanced-toggle
          style="
            --toggleWidth: 280px;
            --labelWidth: 185px;
            --switchWidth: 75px;
            --switchPos: 185px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Attach Point`"
          :labelOff="`Not Attach Point`"
          :checked="!!(localItem.attach_point ?? activeItem.attach_point)"
          @update:modelValue="onFlagChange('attach_point', $event)"
        />
      </div>
    </div>
  </div>
  <div
    v-if="disableActive"
    class="row mt-2 mb-3"
  >
    <div class="col-12 text-center text-white fs-4 mt-3">
      <span class="bb-error-wrap">*** Switches disabled as owned by character ***</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArtefactSwitchesTab',
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    localItem: {
      type: Object,
      required: true,
    },
    onFlagChange: {
      type: Function,
      required: true,
    },
    disableActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
``